import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const MEDIA_URL = "https://leaps-inc.com/media/";

function NavLinks({ onNavigate }) {
  return (
    <>
      <div className="dropdown">
        <Link to="/services" onClick={onNavigate}>
          サービス▾
        </Link>
        <div className="dropdown-panel">
          <Link to="/services" onClick={onNavigate}>
            <b>サービス一覧 →</b>
          </Link>
          <Link to="/services/ai-integration" onClick={onNavigate}>
            AIインテグレーション
          </Link>
          <Link to="/services/blockchain" onClick={onNavigate}>
            ブロックチェーン事業開発
          </Link>
        </div>
      </div>
      <Link to="/cases" onClick={onNavigate}>
        実績
      </Link>
      <Link to="/news" onClick={onNavigate}>
        お知らせ
      </Link>
      <a href={MEDIA_URL}>メディア</a>
      <Link to="/company" onClick={onNavigate}>
        会社概要
      </Link>
      <Link className="header-cta" to="/contact" onClick={onNavigate}>
        <img src="/assets/icn_paperplane.svg" alt="" />
        無料相談
      </Link>
    </>
  );
}

export default function SiteHeader() {
  const dialogRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const close = () => dialogRef.current?.open && dialogRef.current.close();

  // ページを移ったらメニューを閉じる
  // biome-ignore lint/correctness/useExhaustiveDependencies: pathname の変化だけを契機にする
  useEffect(() => {
    close();
  }, [pathname]);

  return (
    <>
      <header className="header">
        <div className="header-inner">
          <Link className="brand" to="/">
            <img src="/assets/logo.svg" alt="LEAPS" />
          </Link>
          <nav aria-label="メインナビゲーション">
            <NavLinks />
          </nav>
          <button
            type="button"
            className="menu-button"
            aria-label="メニューを開く"
            aria-expanded={open}
            aria-controls="mobile-menu"
            onClick={() => {
              dialogRef.current?.showModal();
              setOpen(true);
            }}
          >
            <img src="/assets/icn_menu.svg" alt="" />
          </button>
        </div>
      </header>
      <dialog id="mobile-menu" ref={dialogRef} onClose={() => setOpen(false)}>
        <button
          type="button"
          className="close-menu"
          aria-label="メニューを閉じる"
          onClick={close}
        >
          <img src="/assets/icn_close.svg" alt="" />
        </button>
        <nav aria-label="モバイルナビゲーション">
          <NavLinks onNavigate={close} />
        </nav>
      </dialog>
    </>
  );
}
